module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/january-14a840d9cbc02be5bf108751b549bf85.png";